import request from '@/config/axios'
import type { MarketTemplateVO } from './home'

export interface MarketPortalCategoryVO {
  id?: number
  name?: string
  alias?: string
  icon?: string
  color?: string
  descNames?: string[]
  visible?: boolean
}

export interface MarketPortalSceneVO {
  key?: number
  name?: string
  hideInActivity?: boolean
}

export interface MarketPortalFestivalTabVO {
  key?: number
  name?: string
  templates?: MarketTemplateVO[]
}

export interface MarketPortalTradeRowVO {
  key?: number
  name?: string
  templates?: MarketTemplateVO[]
}

export interface MarketPortalHomeVO {
  categories?: MarketPortalCategoryVO[]
  scenes?: MarketPortalSceneVO[]
  festivalTabs?: MarketPortalFestivalTabVO[]
  tradeRows?: MarketPortalTradeRowVO[]
  hotTemplates?: MarketTemplateVO[]
  hotTotal?: number
}

export interface MarketPortalHomeQuery {
  sceneKey?: number
  hotOffset?: number
}

export interface MarketPortalCategoryPageQuery {
  pageNo?: number
  pageSize?: number
  categoryId?: number
  sortMode?: number
  sceneKey?: number
  festivalKey?: number
}

export interface MarketPortalSearchQuery {
  pageNo?: number
  pageSize?: number
  keyword?: string
}

export const getMarketPortalHome = (params?: MarketPortalHomeQuery) => {
  return request.get<MarketPortalHomeVO>({ url: '/market/portal/home', params })
}

export const getMarketPortalCategoryPage = (params: MarketPortalCategoryPageQuery) => {
  return request.get<{ list: MarketTemplateVO[]; total: number }>({
    url: '/market/portal/category-page',
    params
  })
}

export const getMarketPortalSearch = (params: MarketPortalSearchQuery) => {
  return request.get<{ list: MarketTemplateVO[]; total: number }>({
    url: '/market/portal/search',
    params
  })
}

export interface MarketPortalEditorPrizeVO {
  name?: string
  type?: string
  count?: number
  probability?: number
  prizeType?: number
}

export interface MarketPortalEditorInitVO {
  marketTemplateId?: number
  templateName?: string
  suggestedTitle?: string
  coverUrl?: string
  activityKey?: number
  modGameId?: number
  rstyle?: number
  style?: string
  styleName?: string
  pluginReady?: boolean
  defaultDays?: number
  themeColors?: string[]
  defaultPrizes?: MarketPortalEditorPrizeVO[]
  defaultRulesText?: string
  defaultDailyLimit?: number
  playPagePath?: string
  promotionTemplateId?: number
}

export const getMarketPortalEditorInit = (marketTemplateId: number) => {
  return request.get<MarketPortalEditorInitVO>({
    url: '/market/portal/editor-init',
    params: { marketTemplateId }
  })
}
